class QueryHelper {
    static getQueryParametersStringFromObject(obj: object, propertiesToIgnore: string[]): string {
        const parameters = Object.entries(obj)
            .filter(p => {
                return !propertiesToIgnore.includes(p[0])
            })
            .map(p => {
                return `${p[0]}=${p[1]}`
            })

        if (parameters.length === 0) {
            return ""
        }

        return `?${parameters.join("&")}`
    }
}


export default QueryHelper


// WEBPACK FOOTER //
// ./src/common/QueryHelper.ts